// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px 12px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: var(--background-default);
  border-radius: 16px;
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .header-wrapper {
  text-align: center;
  width: 100%;
}
.wrapper .title {
  font-family: AppFontBold, sans-serif;
  width: 100%;
  font-size: 24px;
  text-transform: uppercase;
  color: var(--color-black);
  padding: 20px 0px 10px;
  text-transform: uppercase;
  text-align: center;
}
.wrapper .description {
  font-family: AppFontMedium;
  font-size: 14px;
  color: var(--color-black);
  padding: 5px 0px 10px;
  text-align: center;
  text-transform: uppercase;
}
.wrapper ion-col .card-item {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: var(--default-background);
  border-radius: var(--custom-border-radius);
  transition: border 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #000;
}
.wrapper ion-col .card-item.selected {
  background: #F5FAFF;
}
.wrapper ion-col .card-item .default-img {
  padding: 5px;
  object-fit: contain !important;
  background-color: #fff;
}
.wrapper ion-col .card-item .image-block {
  width: 100%;
  position: relative;
  margin: 15px 0 8px;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
  aspect-ratio: 512/371;
  object-fit: contain;
}
.wrapper ion-col .card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.wrapper ion-col .card-item .info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.wrapper ion-col .card-item .info-block .name {
  height: 52px;
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  padding: 0 5px;
  margin: 0;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: var(--color-black);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper ion-col .card-item .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  color: #000000;
  margin: 0;
  margin-top: 20px;
  text-align: center;
}

.price {
  margin: 8px 0 0;
  font-weight: 600;
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
  text-align: center;
  font-size: 13px;
  width: 90%;
}

.content_block {
  height: calc(100% - 124px);
  overflow-y: auto;
  width: 100%;
}

.footer-btn {
  width: 100%;
  margin-top: 3%;
  padding: 20px 5px 0;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.footer-btn ion-button {
  margin: 5px 0px;
  --border-radius: 26px;
  width: 100%;
  height: 44px;
  min-width: max-content;
  text-transform: uppercase;
  color: #fff;
  font-size: 18px;
  min-height: 36px;
}
.footer-btn ion-button.checkout-btn:hover {
  --background: var(--primary-btn) !important;
}
.footer-btn ion-button.cancel-btn {
  --background: transparent !important;
  color: var(--color-black);
  text-decoration: underline;
}
.footer-btn ion-button.cancel-btn:hover {
  --background: none !important;
}
.footer-btn:after {
  content: "";
  position: absolute;
  height: 1px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 96%;
  background: var(--color-black);
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: var(--color-black);
  text-align: left;
  padding-top: 6px;
}

.add-button {
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.add-button p {
  font-family: AppFontMedium;
  color: var(--color-black);
  font-size: 14px;
}

.quantity-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  color: var(--color-black);
  font-size: 20px;
  font-family: AppFont;
}
.quantity-selector .quantity-btn {
  width: 30px;
  height: 30px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.selected_item_icon {
  position: absolute;
  top: 7px;
  left: 5px;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  align-items: center;
  background: #f2dbd9;
  border-radius: 20px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  height: 20px;
  z-index: 10;
  scale: 0.8;
}
.selected_item_icon p {
  padding: 0 10px 0 5px;
}
.selected_item_icon ion-icon {
  width: 20px;
  height: 20px;
}

.footer-section {
  padding: 5px 0px 10px;
  min-width: 100%;
  display: flex;
}

.add-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--default-background);
}
.add-icon ion-icon {
  margin: 0 auto;
  font-size: 30px;
}

.selected-circle {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  background: #D2E0F1;
}
.selected-circle ion-icon {
  font-size: 20px;
  transition: opacity 500ms ease-in-out;
}

.footer-btn-text {
  font-size: 18px !important;
  color: white;
  font-family: AppFontBold, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2CAAA;EACA,mBAAA;AADF;AAGE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;EACA,WAAA;AADN;AAKE;EACE,kBAAA;EACA,WAAA;AAHJ;AAME;EACE,oCAAA;EACA,WAAA;EACA,eAAA;EAEA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AALJ;AAQE;EACE,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;AANJ;AAUI;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,qCAAA;EAEA,0CAAA;EAEA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAVN;AAYM;EACE,mBAAA;AAVR;AAaM;EACE,YAAA;EACA,8BAAA;EACA,sBAAA;AAXR;AAcM;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;AAZR;AAkBQ;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAhBV;AAmBQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAjBV;AAqBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAnBR;AAqBQ;EACE,YAAA;EACA,oCAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AApBV;AAuBQ;EACE,cAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AArBV;;AA4BA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAzBF;;AA4BA;EACE,0BAAA;EACA,gBAAA;EACA,WAAA;AAzBF;;AA4BA;EAEE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AA1BF;AA4BE;EACE,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EAiBA,gBAAA;AA1CJ;AA4BM;EACE,2CAAA;AA1BR;AA8BI;EACE,oCAAA;EACA,yBAAA;EACA,0BAAA;AA5BN;AA8BM;EACE,6BAAA;AA5BR;AAkCE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,8BAAA;AAhCJ;;AAoCA;EACE,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAjCF;AAmCE;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAjCJ;;AAqCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAOA,YAAA;AAxCF;AAmCE;EACE,eAAA;EACA,eAAA;AAjCJ;AAsCE;EACE,yBAAA;EACA,eAAA;EACA,oBAAA;AApCJ;AAuCE;EACE,WAAA;EACA,YAAA;AArCJ;AAuCI;EACE,YAAA;AArCN;;AA0CA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAvCF;AAyCE;EACE,qBAAA;AAvCJ;AA0CE;EACE,WAAA;EACA,YAAA;AAxCJ;;AA4CA;EACE,qBAAA;EACA,eAAA;EACA,aAAA;AAzCF;;AA4CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;AAzCF;AA2CE;EACE,cAAA;EACA,eAAA;AAzCJ;;AA8CE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA3CJ;AA6CI;EACE,eAAA;EACA,qCAAA;AA3CN;;AAgDA;EACE,0BAAA;EACA,YAAA;EACA,oCAAA;AA7CF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n  padding: 20px 12px;\n  overflow-x: hidden;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  background-color: var(--background-default);\n  border-radius: 16px;\n\n  .close-icon {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    margin: 0px;\n    background: var(--color-white-accent);\n    width: 35px;\n    height: 35px;\n    padding: 0px;\n    z-index: 99;\n\n    ion-icon {\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n    }\n  }\n\n  .header-wrapper {\n    text-align: center;\n    width: 100%;\n  }\n\n  .title {\n    font-family: AppFontBold, sans-serif;\n    width: 100%;\n    font-size: 24px;\n\n    text-transform: uppercase;\n    color: var(--color-black);\n    padding: 20px 0px 10px;\n    text-transform: uppercase;\n    text-align: center;\n  }\n\n  .description {\n    font-family: AppFontMedium;\n    font-size: 14px;\n    color: var(--color-black);\n    padding: 5px 0px 10px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  ion-col {\n    .card-item {\n      position: relative;\n      margin: 0 auto;\n      flex-grow: 1;\n      min-height: 100%;\n      word-break: break-word;\n      background: var(--default-background);\n\n      border-radius: var(--custom-border-radius);\n\n      transition: border 200ms linear;\n      text-align: center;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-items: center;\n      border: 1px solid #000;\n\n      &.selected {\n        background: #F5FAFF;\n      }\n\n      .default-img {\n        padding: 5px;\n        object-fit: contain !important;\n        background-color: #fff;\n      }\n\n      .image-block {\n        width: 100%;\n        position: relative;\n        margin: 15px 0 8px;\n\n        // &:has(.default_img) {\n        // \tbackground-color: var(--ion-color-primary);\n        // }\n\n        ion-img {\n          width: 100%;\n          height: 100%;\n          aspect-ratio: 512 / 371;\n          object-fit: contain;\n        }\n\n        .plus {\n          position: absolute;\n          top: 10px;\n          right: 10px;\n          height: 32px;\n          width: 32px;\n        }\n      }\n\n      .info-block {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-between;\n        flex-grow: 1;\n\n        .name {\n          height: 52px;\n          font-family: AppFontBold, sans-serif;\n          font-size: 18px;\n          padding: 0 5px;\n          margin: 0;\n          display: flex;\n          align-items: center;\n          text-transform: uppercase;\n          color: var(--color-black);\n          word-break: break-word;\n\n          display: -webkit-box;\n          -webkit-line-clamp: 3;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .deposit_text {\n          font-size: 9px;\n          font-family: AppFont, sans-serif;\n          color: #000000;\n          margin: 0;\n          margin-top: 20px;\n          text-align: center;\n        }\n      }\n    }\n  }\n}\n\n.price {\n  margin: 8px 0 0;\n  font-weight: 600;\n  color: var(--color-black);\n  font-family: AppFontMedium, sans-serif;\n  text-align: center;\n  font-size: 13px;\n  width: 90%;\n}\n\n.content_block {\n  height: calc(100% - 124px);\n  overflow-y: auto;\n  width: 100%;\n}\n\n.footer-btn {\n  // position: fixed;\n  width: 100%;\n  margin-top: 3%;\n  padding: 20px 5px 0;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n\n  ion-button {\n    margin: 5px 0px;\n    --border-radius: 26px;\n    width: 100%;\n    height: 44px;\n    min-width: max-content;\n    text-transform: uppercase;\n    color: #fff;\n    font-size: 18px;\n\n    &.checkout-btn {\n      &:hover {\n        --background: var(--primary-btn) !important;\n      }\n    }\n\n    &.cancel-btn {\n      --background: transparent !important;\n      color: var(--color-black);\n      text-decoration: underline;\n\n      &:hover {\n        --background: none !important;\n      }\n    }\n    min-height: 36px;\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    height: 1px;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 96%;\n    background: var(--color-black);\n  }\n}\n\n.measurment_text {\n  font-family: AppFont, sans-serif;\n  font-size: 10px;\n  color: var(--color-black);\n  text-align: left;\n  padding-top: 6px;\n}\n\n.add-button {\n  width: 100%;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  p {\n    font-family: AppFontMedium;\n    color: var(--color-black);\n    font-size: 14px;\n  }\n}\n\n.quantity-selector {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ion-icon {\n    margin: 0px 6px;\n    cursor: pointer;\n  }\n\n  z-index: 999;\n\n  .quantity {\n    color: var(--color-black);\n    font-size: 20px;\n    font-family: AppFont;\n  }\n\n  .quantity-btn {\n    width: 30px;\n    height: 30px;\n\n    &.add-opacity {\n      opacity: 0.5;\n    }\n  }\n}\n\n.selected_item_icon {\n  position: absolute;\n  top: 7px;\n  left: 5px;\n  transition: opacity 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  background: #f2dbd9;\n  border-radius: 20px;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: 0 auto;\n  height: 20px;\n  z-index: 10;\n  scale: 0.8;\n\n  p {\n    padding: 0 10px 0 5px;\n  }\n\n  ion-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.footer-section {\n  padding: 5px 0px 10px;\n  min-width: 100%;\n  display: flex;\n}\n\n.add-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: var(--default-background);\n\n  ion-icon {\n    margin: 0 auto;\n    font-size: 30px;\n  }\n}\n\n\n  .selected-circle {\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 5px;\n    background: #D2E0F1;\n\n    ion-icon {\n      font-size: 20px;\n      transition: opacity 500ms ease-in-out;\n    }\n  }\n\n\n.footer-btn-text {\n  font-size: 18px !important;\n  color: white;\n  font-family: AppFontBold, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
